import React, { Component } from 'react';
import { Rect, Group } from 'react-konva';

export class VerticalDayTimesheetComponentCanvas extends Component {
    render() {
        const { geometry, component, isSelected, dimentionsRatio, draggable } = this.props;

        const geometryWidthRatio = geometry.width / 300.0;
        const geometryHeightRatio = geometry.height / 900.0;

        const smallHeight = 50 * geometryHeightRatio * dimentionsRatio;
        const bigHeight = 200 * geometryHeightRatio * dimentionsRatio;
        const width = 200 * geometryWidthRatio * dimentionsRatio;

        const elementsPosX = geometry.drawPositionX + 50 * geometryWidthRatio * dimentionsRatio;

        const descriptionPosY = geometry.drawPositionY + 50 * geometryHeightRatio * dimentionsRatio;
        let tableElementPosY = geometry.drawPositionY + 300 * geometryHeightRatio * dimentionsRatio;

        const componentSecundaryColor = "#EBF5FA";
        const geometryWidth = geometry.width * dimentionsRatio;
        const geometryHeight = geometry.height * dimentionsRatio;

        const rowElements = [];
        let i;
        for (i = 0; i < 6; i++) {
            rowElements.push(
                <Rect key={i}
                    x={elementsPosX}
                    y={tableElementPosY}
                    width={width}
                    height={smallHeight}
                    strokeWidth={1}
                    stroke="black"
                    fill={componentSecundaryColor} />
            );

            tableElementPosY += smallHeight + 50 * geometryHeightRatio * dimentionsRatio;
        }

        return (
            <Group
                offsetX={geometry.offsetX}
                offsetY={geometry.offsetY}
                draggable={draggable}
                onDragEnd={this.props.onDragEnd}
                onClick={this.props.onComponentClick ? () => this.props.onComponentClick(component.internalId) : null} >
                <Rect x={geometry.drawPositionX}
                    y={geometry.drawPositionY}
                    width={geometryWidth}
                    height={geometryHeight}
                    strokeWidth={isSelected ? 3 : 1}
                    stroke={isSelected ? "#6699ff" : "black"}
                    fill={component.color} />

                <Group>
                    <Rect x={elementsPosX}
                        y={descriptionPosY}
                        width={width}
                        height={bigHeight}
                        strokeWidth={1}
                        stroke="black"
                        fill={componentSecundaryColor} />
                </Group>

                <Group>
                    {rowElements}
                </Group>
            </Group>
        );
    }
}
